export type CurrencyId =
	| "BTC"
	| "ETH"
	| "USDT"
	| "USDC"
	| "MATIC"
	| "BNB"
	| "TRX";

export interface Currency {
	id: CurrencyId;
	label: string;
	iconName: string;
	color: string;
}

export const currencies: Record<CurrencyId, Currency> = {
	BTC: { id: "BTC", label: "Bitcoin", iconName: "btc", color: "#f7931a" },
	ETH: { id: "ETH", label: "Ethereum", iconName: "eth", color: "#3b82f6" },
	USDT: { id: "USDT", label: "Tether", iconName: "usdt", color: "#26a17b" },
	USDC: { id: "USDC", label: "USD Coin", iconName: "usdc", color: "#2775ca" },
	MATIC: { id: "MATIC", label: "Polygon", iconName: "matic", color: "#8b5cf6" },
	BNB: { id: "BNB", label: "BNB", iconName: "bnb", color: "#f59e0b" },
	TRX: { id: "TRX", label: "TRON", iconName: "tron", color: "#dc2626" },
};

export const currencyList: Currency[] = Object.values(currencies);

export const getCurrency = (id: string): Currency | undefined =>
	currencies[id.toUpperCase() as CurrencyId];
